import React from 'react';
import { AppBar, Toolbar, Container, Typography, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Logout from '../Auth/Logout';
import { useAuth } from '../../contexts/AuthContext';
import CustomLink from '../Custom/CustomLink';

const Header = () => {
  const { currentUser } = useAuth();

  return (
    <AppBar position="sticky" elevation={1} sx={{ bgcolor: '#ffffff', color: '#111827' }}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography
            variant="h5"
            component={RouterLink}
            to="/"
            sx={{
              fontWeight: 700,
              color: '#111827',
              textDecoration: 'none',
              letterSpacing: '0.05em',
            }}
          >
            ArchFlow
          </Typography>

          <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
            {/* {currentUser && <CustomLink to="/dashboard">Dashboard</CustomLink>} */}
            {/* {currentUser && <CustomLink to="/projects">Projetos</CustomLink>} */}
            {currentUser && <CustomLink to="/pricing">Precificação</CustomLink>}
            {currentUser && <CustomLink to="/client">Clientes</CustomLink>}
            {currentUser && <CustomLink to="/company">Empresa</CustomLink>}

            {currentUser && <Logout />}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
